/** Sign in with Google (Google Identity Services button). The ID token is verified by the DSM, never here. */
import { useEffect, useRef, useState } from "react";
import { loadScript } from "../scripts";

declare global {
  interface Window {
    google?: any;
  }
}

export function GoogleSignIn({ clientId, onCredential }: { clientId: string; onCredential: (t: string) => void }) {
  const host = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadScript("https://accounts.google.com/gsi/client")
      .then(() => {
        if (cancelled || !host.current || !window.google) return;
        window.google.accounts.id.initialize({ client_id: clientId, callback: (r: any) => onCredential(r.credential) });
        window.google.accounts.id.renderButton(host.current, { theme: "outline", size: "large", locale: "vi" });
      })
      .catch(() => setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [clientId, onCredential]);

  return (
    <div className="signin">
      <div ref={host} />
      {failed && <p role="alert">Không tải được nút đăng nhập Google. Kiểm tra mạng rồi tải lại trang.</p>}
    </div>
  );
}
